import http from "./http.service";
import * as CryptoJS from "crypto-js";
import { v4 as uuidv4 } from "uuid";
import _sodium from "libsodium-wrappers";
import base64 from "base-64";
import { store } from "../store";
import {
  SET_DEVICE_ID,
  SET_LOGIN_DETAILS,
  SET_LOGIN_VERIFY_DETAILS,
  SET_QUICK_LINKS_DATA,
  SET_SERVER_KEY,
  SET_SHARED_KEY,
} from "../store/constants";
import { API_CONFIG } from "./constants/constant";
import { CONFIG } from "../environment";

const AES_SECRET_KEY = CryptoJS.enc.Utf8.parse(CONFIG.ENCRYPT_KEY);

export const encryptAES = (text) =>
  CryptoJS.AES.encrypt(text, AES_SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

const postLogin = async (data, routingPath = "dashboard") => {
  try {
    const reqParams = {
      ...data,
      password: encryptAES(data.password), //  "2R+tTCMLsNjFSf+cTjcIRA==",
      module: "LOGIN",
      requestId: "IBLOGIN",
    };
    // store.dispatch({ type: "USER_LOGOUT" });
    const response = await http.post(API_CONFIG.LOGIN, reqParams);

    store.dispatch({
      type: SET_LOGIN_VERIFY_DETAILS,
      payload: { ...response.data, routingPath: routingPath },
    });
    return { status: response.status, data: response.data };
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};

const internetloginverify = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "LOGIN",
      requestId: "IBLOGIN",
      password: encryptAES(data.password), //  "2R+tTCMLsNjFSf+cTjcIRA==",
    };
    const response = await http.post(API_CONFIG.internetloginverify, reqParams);
    if (response.status === 200) {
      response.data.profileSelection = response.data.profileSelection || [];
      response.data.profileSelection.forEach((element, idx) => {
        if (idx === 0) {
          element.active = true;
        } else {
          element.active = false;
        }
      });
    }
    store.dispatch({ type: SET_LOGIN_DETAILS, payload: response.data });
    return { status: response.status, data: response.data };
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};

const postLogout = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "LOGOUT",
    };
    const response = await http.post(API_CONFIG.LOGOUT, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const forceChangePasswordVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      currentPassword: encryptAES(data.currentPassword),
      newPassword: encryptAES(data.newPassword),
      requestId: "FORCECHANGEPWD",
      // userName: loginDetails?.userName,
      module: "CHANGEPASSWORD",
    };
    const response = await http.post(
      API_CONFIG.forceChangePasswordVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const forceChangePasswordConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      currentPassword: encryptAES(data.currentPassword),
      newPassword: encryptAES(data.newPassword),
      requestId: "FORCECHANGEPWD",
      // userName: loginDetails?.userName,
      module: "CHANGEPASSWORD",
    };
    const response = await http.post(
      API_CONFIG.forceChangePasswordConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getCallUsDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      module: "INFO",
      requestId: "Important Notice",
    };
    const response = await http.post(API_CONFIG.metadata, reqParams);
    return { status: response.status, data: response.data["contactUs"] || [] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getMetaDataDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      module: "GENERAL",
      requestId: "METADATA",
    };
    const response = await http.post(API_CONFIG.metadata, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getFAQDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      requestId: "FAQ",
      module: "INFO",
    };
    const response = await http.post(API_CONFIG.userfaq, reqParams);
    return { status: response.status, data: response.data["faqList"] || [] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLocations = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      //locationType: "ALL",
      requestId: "VERIFY_DEVICE",
      module: "MPINLOGIN",
      userGroupId: "0",
    };
    const response = await http.post(API_CONFIG.getLocations, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getPrivacyPolicyApi = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      requestId: "PRIVACYPOLICY",
      module: "LOGIN",
    };

    const response = await http.post(API_CONFIG.getPrivacyPolicy, reqParams);
    // downloadFileFromUrl(response.data["url"], "Privacy Policy");
    window.open(response.data["url"], "_blank");
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getSecurityTipsApi = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      module: "SAFTEY_TIPS",
      requestId: "TERMS",
    };
    const response = await http.post(API_CONFIG.getSecurityTips, reqParams);
    // downloadFileFromUrl(response.data["url"], "Security Tips");
    window.open(response.data["url"], "_blank");
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const forgotUserIdVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: data?.mobileNumber,
      requestId: "forgotUserIdVerify",
      module: "LOGIN",
    };
    const response = await http.post(API_CONFIG.forgotUserIdVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const forgotUserIdConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: data?.mobileNumber,
      requestId: "forgotUserIdVerify",
      module: "LOGIN",
    };
    const response = await http.post(API_CONFIG.forgotUserIdConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const forgotPwdVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "forgotPwd",
      module: "LOGIN",
    };
    const response = await http.post(API_CONFIG.forgotPwdVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const forgotPwdConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "forgotPwd",
      module: "LOGIN",
    };
    const response = await http.post(API_CONFIG.forgotPwdConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getCustImpNotifications = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "GETNOTIFICATIONS",
    };
    const response = await http.post(
      API_CONFIG.getCustImpNotifications,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const generateKey = async (data) => {
  try {
    let uniqueId = await uuidv4();

    store.dispatch({ type: SET_DEVICE_ID, payload: uniqueId });
    await _sodium.ready;
    const Sodium = _sodium;
    const clientKeyPair = await Sodium.crypto_box_keypair("uint8array");

    const reqParams = {
      clientId: base64.encode(uniqueId),
      clientKey: Sodium.to_base64(
        clientKeyPair?.publicKey,
        Sodium.base64_variants.ORIGINAL
      ),
      encryptionNotReqd: true,
      requestId: "META_DATA",
      language: "en",
      channelType: "INTERNET",
      ipAddress: "0.0.0.0",
    };

    const response = await http.post(
      API_CONFIG.PUBLIC_KEY_GENERATION,
      reqParams
    );
    if (response.status === 200) {
      store.dispatch({
        type: SET_SERVER_KEY,
        payload: response.data.serverKey,
      });

      const sharedKey = await Sodium.crypto_box_beforenm(
        Sodium.from_base64(
          response.data.serverKey,
          Sodium.base64_variants.ORIGINAL
        ),
        clientKeyPair.privateKey,
        "uint8array"
      );

      store.dispatch({ type: SET_SHARED_KEY, payload: sharedKey });

      return {
        status: response.status,
        data: { ...response.data, sharedKey: sharedKey, uniqueId: uniqueId },
      };
    }
    // } else {
    //   return { status: 200, data: app?.serverKey };
    // }
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};

const registerVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      mode: "",
      module: "REGISTRATION",
      requestId: "REG_VERIFY",
      userGroupId: 0,
      relationshipType: CONFIG.CIF ? "CIF" : "ACCOUNT",
    };
    const response = await http.post(API_CONFIG.SIGNUP_VERIFY, reqParams);
    return { status: response.status, data: response.data["data"] || {} };
  } catch (err) {
    return Promise.reject(err);
  }
};

const registerConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "REGISTRATION",
      requestId: "REG_CONFIRM",
      userGroupId: 0,
      mode: "",
      relationshipType: CONFIG.CIF ? "CIF" : "ACCOUNT",
      password: encryptAES(data.password),
    };
    const response = await http.post(API_CONFIG.SIGNUP_CONFIRM, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const registerUsernameCheck = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "REGISTRATION",
      requestId: "REG_VERIFY",
      userGroupId: 0,
      mode: "",
    };
    const response = await http.post(
      API_CONFIG.SIGNUP_USERNAME_CHECK,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const resendOTP = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "RESENDOTP",
      userGroupId: 0,
      mode: "",
    };
    const response = await http.post(API_CONFIG.RESEND_OTP, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};
const registerIdentity = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "REGISTRATION",
      sessionUser: "PUBLIC",
    };
    const response = await http.post(API_CONFIG.registerIdentity, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getallExchangeRates = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "LOCATIONS",
      userName: "",
    };
    const response = await http.post(API_CONFIG.getallExchangeRates, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const calculateLoanDepositResult = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      requestId: "loan",
      module: "register",
    };
    const response = await http.post(
      API_CONFIG.calculateLoanDepositResult,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getTermsAndConditions = async (data) => {
  try {
    const reqParams = {
      userName: "DEFAULT",
      requestId: "GET_TERMS_CONDITIONS",
      module: "GENERAL",
      ...data,
    };

    const response = await http.post(
      API_CONFIG.getTermsAndConditions,
      reqParams
    );
    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getSecurityTips = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      requestId: "PRIVACYPOLICY",
      module: "GENERAL",
    };

    const response = await http.post(
      API_CONFIG.getTermsAndConditions,
      reqParams
    );
    window.open(response.data["url"], "_blank");
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getPrivacyPolicy = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      requestId: "PRIVACYPOLICY",
      module: "GENERAL",
    };

    const response = await http.post(API_CONFIG.getPrivacyPolicy, reqParams);
    window.open(response.data["url"], "_blank");
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getFeedbackCategory = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "FEEDBACK",
      module: "USSD",
    };

    const response = await http.post(API_CONFIG.getFeedbackCategory, reqParams);
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const createFeedback = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "FEEDBACK",
      module: "USSD",
    };

    const response = await http.post(API_CONFIG.createFeedback, reqParams);
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const forgotUsernameVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "FORGOTUSERNAME",
      module: "FORGOTUSERNAME",
      relationshipType: "",
    };

    const response = await http.post(
      API_CONFIG.forgotUsernameVerify,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const forgotUsernameConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "FORGOTUSERNAME",
      module: "FORGOTUSERNAME",
      relationshipType: "",
    };

    const response = await http.post(
      API_CONFIG.forgotUsernameConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getIdentityTypes = async (data) => {
  try {
    const response = await http.post(API_CONFIG.getIdentityTypes, {});
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const forgortPasswordVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "forgotPwd",
      module: "LOGIN",
      userGroupId: 0,
    };
    const response = await http.post(
      API_CONFIG.FORGOT_PASSWORD_VERIFY,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const forgotPasswordConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "REGISTRATION",
      requestId: "FORGOT_PWD_CONFIRM",
      userGroupId: 0,
      userPassword: encryptAES(data.userPassword),
      mode: "",
    };
    const response = await http.post(
      API_CONFIG.FORGOT_PASSWORD_CONFIRM,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const selfUnLockVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "SELFUNLOCK",
      requestId: "SELFUNLOCK",
      mode: "",
    };
    const response = await http.post(API_CONFIG.selfUnLockVerify, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const selfUnLockConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "SELFUNLOCK",
      requestId: "SELFUNLOCK",
    };
    const response = await http.post(API_CONFIG.selfUnLockConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const kikRefreshToken = async () => {
  try {
    const { auth, app } = store.getState();
    const { profileDetails } = app;
    const response = await http.post(API_CONFIG.refreshToken, {
      requestId: "REFRESHLOGIN",
      module: "LOGIN",
      refreshToken: auth?.refreshToken,
      userName: app?.loginDetails?.userName,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    });
    return {
      refresh_token: response?.headers?.refresh_token,
      access_token: response?.headers?.access_token,
      status: response.status,
    };
  } catch (err) {}
};

const getQuickLinks = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "",
      requestId: "GET_QUICK_ACCESS_MENU",
    };
    const response = await http.post(API_CONFIG.getQuickAccessMenu, reqParams);
    store.dispatch({
      type: SET_QUICK_LINKS_DATA,
      payload: { ...response.data.data["quickAccessMenu"] },
    });
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getRegion = async (data) => {
  try {
    const reqParams = {
      ...data,
      userName: "DEFAULT",
      requestId: "VERIFY_DEVICE",
      module: "MPINLOGIN",
      // userGroupId: "0",
      // id: "1",
    };
    const response = await http.post(API_CONFIG.getRegion, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getinterestValues = async () => {
  try {
    const reqParams = {
      userName: "DEFAULT",
      requestId: "COMPOUND_INTEREST",
      module: "INFORMATION",
    };
    const response = await http.post(API_CONFIG.getinterestValues, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getCountryCodes = async () => {
  try {
    const reqParams = {
      userName: "DEFAULT",
      module: "GENERAL",
      requestId: "COUNTRY_CODES",
    };
    const response = await http.post(API_CONFIG.getCountryCodes, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const AuthService = {
  postLogin,
  postLogout,
  forceChangePasswordVerify,
  forceChangePasswordConfirm,
  getCallUsDetails,
  getFAQDetails,
  getLocations,
  getPrivacyPolicyApi,
  getSecurityTipsApi,
  internetloginverify,
  forgotUserIdVerify,
  forgotUserIdConfirm,
  forgotPwdConfirm,
  forgotPwdVerify,
  getMetaDataDetails,
  getCustImpNotifications,
  generateKey,
  registerVerify,
  registerConfirm,
  registerIdentity,
  getallExchangeRates,
  calculateLoanDepositResult,
  getTermsAndConditions,
  getPrivacyPolicy,
  getSecurityTips,
  getFeedbackCategory,
  createFeedback,
  forgotUsernameVerify,
  forgotUsernameConfirm,
  getIdentityTypes,
  resendOTP,
  registerUsernameCheck,
  forgortPasswordVerify,
  forgotPasswordConfirm,
  selfUnLockVerify,
  selfUnLockConfirm,
  kikRefreshToken,
  getQuickLinks,
  getRegion,
  getinterestValues,
  getCountryCodes,
};

export default AuthService;
